/*
  Vero — meerdere foto's per kleurvariant.

  Shopify koppelt standaard maar 1 foto aan een variant. Dit script laat de
  productgalerij alle foto's tonen die bij de gekozen kleur horen, op basis van
  de ALT-TEKST van elke foto.

  Werking (voor Bas, in de admin):
  - Zorg dat het product een optie "Kleur" heeft (waarden bv. "Zwart/Goud" en "Blauw/Goud").
  - Zet in de alt-tekst van elke foto de kleurnaam die erbij hoort
    (Products > Vero Core > Media > klik foto > "Alt text" / "Edit alt text").
    Bv. alt-tekst "Vero Core padelracket Zwart/Goud voorkant".
  - Foto's zonder kleurnaam in de alt-tekst worden bij ELKE kleur getoond
    (handig voor sfeer-/detailfoto's die altijd zichtbaar mogen zijn).

  Geen kleur-optie op het product? Dan doet dit script niets.

  Techniek: we luisteren met een MutationObserver op de galerij, zodat we
  opnieuw filteren zodra Dawn bij een variantwissel de media bijwerkt. Dat is
  betrouwbaarder dan de pub/sub-events (die soms te vroeg/niet aankomen).
*/
(function () {
  const HIDDEN_CLASS = 'vero-variant-hidden';

  function getColors(gallery) {
    const raw = gallery && gallery.getAttribute('data-vero-colors');
    if (!raw) return [];
    return raw
      .split('|')
      .map((c) => c.trim())
      .filter(Boolean);
  }

  // Hoort een alt-tekst bij een kleur? Matcht op de volledige waarde
  // ("Zwart/Goud") of op het eerste woord ervan ("Zwart"), zodat ook een
  // alt-tekst met maar één woord werkt.
  function altMatchesColor(altLower, color) {
    const cl = color.toLowerCase();
    if (altLower.indexOf(cl) !== -1) return true;
    const first = cl.split(/[^a-z0-9]+/).filter(Boolean)[0];
    return !!first && altLower.indexOf(first) !== -1;
  }

  function matchColorFromValues(values, colors) {
    for (const v of values || []) {
      const vl = String(v).toLowerCase();
      for (const c of colors) {
        if (c.toLowerCase() === vl || altMatchesColor(vl, c)) return c;
      }
    }
    return null;
  }

  // Bepaal de nu geselecteerde kleur, in volgorde van betrouwbaarheid:
  // 1) expliciet meegegeven optiewaarden, 2) de alt-tekst van de actieve
  // hoofdfoto (die Dawn synchroon op de variant-hoofdfoto zet), 3) de
  // variant-JSON in de DOM.
  function currentColor(productInfo, colors, optionValues) {
    if (optionValues && optionValues.length) {
      const c = matchColorFromValues(optionValues, colors);
      if (c) return c;
    }

    const activeImg = productInfo.querySelector('.product__media-list > li.is-active img');
    const activeAlt = ((activeImg && activeImg.getAttribute('alt')) || '').toLowerCase();
    if (activeAlt) {
      for (const c of colors) if (altMatchesColor(activeAlt, c)) return c;
    }

    const el = productInfo.querySelector('[data-selected-variant]');
    if (el) {
      try {
        const c = matchColorFromValues((JSON.parse(el.textContent) || {}).options || [], colors);
        if (c) return c;
      } catch (e) {
        /* geen geldige JSON: negeren */
      }
    }
    return null;
  }

  // Welke kleur hoort bij deze foto (op basis van de alt-tekst)? null = geen.
  function itemColor(item, colors) {
    const img = item.querySelector('img');
    const alt = ((img && img.getAttribute('alt')) || '').toLowerCase();
    if (!alt) return null;
    for (const c of colors) {
      if (altMatchesColor(alt, c)) return c;
    }
    return null;
  }

  function applyFilter(productInfo, optionValues) {
    const gallery = productInfo.querySelector('media-gallery');
    const colors = getColors(gallery);
    if (colors.length === 0) return; // geen kleur-optie: niets doen

    const color = currentColor(productInfo, colors, optionValues);
    if (!color) return; // kleur onbekend: alles laten staan

    const viewerItems = productInfo.querySelectorAll('.product__media-list > li');
    const thumbItems = productInfo.querySelectorAll('.thumbnail-list > li');
    const modalItems = productInfo.querySelectorAll('.product-media-modal__content [data-media-id]');

    const shouldShow = (item) => {
      const ic = itemColor(item, colors);
      return ic === null || ic === color; // gedeeld of juiste kleur
    };

    [viewerItems, thumbItems, modalItems].forEach((list) => {
      list.forEach((item) => item.classList.toggle(HIDDEN_CLASS, !shouldShow(item)));
    });

    // Zorg dat de juiste foto groot getoond wordt. Door foto's op display:none
    // te zetten kan Dawn's slider zijn positie kwijtraken, waardoor de grote foto
    // leeg blijft tot je klikt. We forceren daarom dezelfde herpositionering die
    // een klik ook doet (setActiveMedia). Voorkeur: de actieve foto als die bij
    // de kleur past; anders de eerste zichtbare foto.
    const activeViewer = productInfo.querySelector('.product__media-list > li.is-active');
    let target =
      activeViewer && !activeViewer.classList.contains(HIDDEN_CLASS) ? activeViewer : null;
    if (!target) {
      target = Array.prototype.find.call(
        viewerItems,
        (li) => !li.classList.contains(HIDDEN_CLASS)
      );
    }
    if (target && gallery.setActiveMedia) {
      gallery.setActiveMedia(target.dataset.mediaId, false);
    }

    // Teller "x / y" bijwerken naar het aantal zichtbare foto's.
    const total = productInfo.querySelector('.slider-counter--total');
    if (total) {
      const visible = Array.prototype.filter.call(
        viewerItems,
        (li) => !li.classList.contains(HIDDEN_CLASS)
      ).length;
      total.textContent = visible;
    }
  }

  // Filter + blijf luisteren: zodra Dawn de media wijzigt (variantwissel),
  // filteren we opnieuw. De 'applying'-vlag voorkomt dat onze eigen wijzigingen
  // de observer in een lus brengen.
  function setup(productInfo) {
    const gallery = productInfo.querySelector('media-gallery');
    const list = productInfo.querySelector('.product__media-list');
    if (!gallery || getColors(gallery).length === 0 || !list) return;

    applyFilter(productInfo);

    let applying = false;
    const observer = new MutationObserver(() => {
      if (applying) return;
      applying = true;
      applyFilter(productInfo);
      setTimeout(() => {
        applying = false;
      }, 0);
    });
    observer.observe(list, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function init() {
    const run = () => document.querySelectorAll('product-info').forEach(setup);
    run();
    // Nogmaals nadat alles (slider + afbeeldingen) volledig geladen is, om
    // race-condities bij het laden op te vangen.
    window.addEventListener('load', () =>
      document.querySelectorAll('product-info').forEach((pi) => applyFilter(pi))
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
